module.exports = __webpack_public_path__ + "./images/9dafd27da2a416b3d46200829c59a153.jpg";